const audioData = [
    [
        {
            id: 0,
            name: "printer",
            audioSource: "sound/telegram.mp3"
        }
    ],
    [
        {
            id: 0,
            name: "recordingLarryMain",
            audioSource: "sound/voiceover/larry_phase_one.mp3"
        }
    ],
    [
        {
            id: 0,
            name: "recordingLarryMain",
            audioSource: "sound/voiceover/larry_phase_two.mp3"
        }
    ],
    [
        {
            id: 0,
            name: "recordingLarryMain",
            audioSource: "sound/voiceover/larry_phase_three.mp3"
        }
    ],
    [
        {
            id: 0,
            name: "recordingLarryMain",
            audioSource: "sound/voiceover/larry_phase_four.mp3"
        },
        {
            id: 1,
            name: "jackRecording",
            audioSource: "sound/voiceover/jack.mp3"
        }
    ],
    [
        {
            id: 0,
            name: "recordingLarryMain",
            audioSource: "sound/voiceover/larry_phase_five.mp3"
        }
    ],
    [
        {
            id: 0,
            name: "noirSting",
            audioSource: "sound/noirSting.mp3"
        }
    ],
    [
        // DEBRIEF PAGE
    ]
]

export default audioData